import type { QuoteLinkParams } from "@/lib/quote-links";

const VALID_INTENTS: ReadonlySet<string> = new Set([
  "diagnostic", "revenue_fix", "revenue_engine", "fix", "improve", "rebuild", "ongoing",
]);
const VALID_CHALLENGES: ReadonlySet<string> = new Set([
  "slow", "not_converting", "conversion_friction", "technical_seo_visibility", "measurement_data",
  "custom_features", "migrating", "ongoing_help",
]);

export function validateQuoteSearch(input: Record<string, unknown>): QuoteLinkParams {
  const out: QuoteLinkParams = {};
  const intent = input.intent;
  if (typeof intent === "string" && VALID_INTENTS.has(intent)) {
    out.intent = intent as QuoteLinkParams["intent"];
  }
  const challenge = input.challenge;
  if (typeof challenge === "string" && VALID_CHALLENGES.has(challenge)) {
    out.challenge = challenge as QuoteLinkParams["challenge"];
  }
  const source = input.source;
  if (typeof source === "string" && source.length > 0 && source.length <= 80) {
    out.source = source;
  }
  const referral = input.ref;
  if (typeof referral === "string" && /^[a-z0-9][a-z0-9-]{2,79}$/i.test(referral)) {
    out.ref = referral.toLowerCase();
  }
  return out;
}

export function hasQuoteParams(s: QuoteLinkParams | undefined): boolean {
  if (!s) return false;
  return Boolean(s.intent || s.challenge || s.source || s.ref);
}
